const getWigsType = (wig) => {
    if (wig.is_repair) {
        return 'repair'
    }

    return 'new-wig'
}

export default getWigsType
